import {useTranslation} from 'react-i18next';

import {Button} from '@edna/components';
import {H1} from '@edna/components/primitives';

import * as S from './style';

export const ErrorBoundary = () => {
  const {t} = useTranslation();

  const handleRefreshPage = () => window.location.reload();

  return (
    <S.ServiceUnavailable>
      <div>
        <H1>{t('ServiceUnavailable:title')}</H1>
        <S.Text>{t('ServiceUnavailable:checkNetworkConnect')}</S.Text>
        <S.Hint>{t('ServiceUnavailable:hint')}</S.Hint>
        <Button
          onClick={handleRefreshPage}
          appearance="primary"
          data-selector="ServiceUnavailable:refreshPage"
        >
          {t('ServiceUnavailable:refreshPage')}
        </Button>
      </div>
      <S.UnavailableImage />
    </S.ServiceUnavailable>
  );
};
